<template>
	<v-layout row v-if="!dataSame">
		<v-flex xs6>
			<old-version-marker/>
			<offer-name
				v-model="old"
				readonly="true"
			></offer-name>
		</v-flex>
		<v-flex xs6>
			<new-version-marker/>
			<offer-name
				v-model="current"
				readonly="true"
			></offer-name>
		</v-flex>
	</v-layout>
</template>
<script>
	import NewVersionMarker from "./NewVersionMarker";
	import OfferName from "../components/OfferName";
	import OldVersionMarker from "./oldVersionMarker";

	export default {
		name: 'compareTitles',
		components: {NewVersionMarker, OfferName, OldVersionMarker},

		computed: {
			dataSame () {
				let comparisonResult = this.current === this.old;
				if (comparisonResult === false) {
					this.$emit('dataDiffer', true);
				}
				return comparisonResult;
			}
		},

		props: {
			current: {},
			old: {},
		}
	};
</script>
